import { IState } from 'constants/countriesStates'
import { getStatesByCountry } from './getStatesByCountry'

/**
 * @example getStateArray(['US']) // [['US', [{ abbr: 'AL', name: 'Alabama' }, ...] ]]
 */
export const getStateArray = (includeCountries: string[] = ['US', 'CA']): [string, IState[]][] => {
  return includeCountries.map(countryKey => {
    return [countryKey, getStatesByCountry(countryKey)]
  })
}
